// Public site: booking wizard, payment return pages and My bookings.
// Keys are the Arabic source strings (what the Arabic UI shows); values are English.
// The browser receives only this file on the English pages, so every string the
// client components show is listed here, including the shared UI kit strings
// (country names, Close, Loading…) and strings the prototype catalog also has.
// apps/web/src/lib/messages.test.ts checks that nothing is missing.
export const webBookingEn: Readonly<Record<string, string>> = {
  بياناتك: 'Your details',
  'نطابقها مع البطاقة عند الاستلام. صور المستندات تُحفظ بشكل آمن.':
    'We match it with your ID card at pickup. Document photos are stored securely.',
  'الاسم الكامل كما في البطاقة': 'Full name as on ID card',
  'اكتب اسمك الكامل': 'Enter your full name',
  'مثال: سالم بن خلفان الحارثي': 'e.g. Salem bin Khalfan Al Harthi',
  'رقم الهاتف (واتساب)': 'Phone number (WhatsApp)',
  'رقم عُماني من 8 أرقام': 'An 8-digit Omani number',
  'رقم الهاتف غير صحيح': 'This phone number is not valid',
  'الرقم المدني أو رقم الجواز': 'Civil ID or passport number',
  'اكتب الرقم كما في البطاقة': 'Enter the number as it appears on your ID',
  'الرقم المدني هو نفسه رقم رخصة القيادة': 'Your civil number is also your driving licence number',
  'صورة البطاقة الشخصية / جواز السفر': 'ID card / passport photo',
  'صورة رخصة القيادة': 'Driving licence photo',
  'نوع الملف غير مدعوم. استخدم JPG أو PNG أو PDF.': 'This file type is not supported. Use JPG, PNG or PDF.',
  'جارٍ الرفع…': 'Uploading…',
  'اضغط للتغيير': 'tap to change',
  'اسحب الملف هنا أو اضغط للرفع': 'Drag the file here or click to upload',
  'شروط الإيجار': 'Rental terms',
  'اقرأها قبل الدفع. ستجدها أيضاً في العقد المرسل على واتساب.':
    "Read these before paying. You'll also find them in the contract sent on WhatsApp.",
  'العمر والرخصة': 'Age and licence',
  'يجب ألا يقل عمر السائق عن 21 سنة، ورخصة سارية لمدة سنة على الأقل.':
    'Drivers must be at least 21 years old, with a licence valid for at least one year.',
  'لا إلغاء · تحويل إلى رصيد': 'No cancellation · convert to credit',
  'لا يمكن إلغاء الحجز. يمكنك تحويله إلى رصيد بقيمة ما دفعته إذا طلبت ذلك قبل {period} ({hours} ساعة) على الأقل من موعد الاستلام، من صفحة «حجوزاتي». يُستخدم الرصيد في أي حجز قادم. بعد ذلك يصبح الحجز غير قابل للاسترداد.':
    "Bookings can't be cancelled. You can convert yours to credit worth what you paid if you ask at least {period} ({hours} hours) before pickup, from My bookings. The credit can be used on any future booking. After that, the booking is non-refundable.",
  العربون: 'Deposit',
  'العربون ({pct}) يُخصم من الإجمالي، والباقي يُدفع عند الاستلام.':
    'The deposit ({pct}) is deducted from the total, and the rest is paid at pickup.',
  الشحن: 'Charging',
  'تُسلَّم السيارة بشحن لا يقل عن 85%، ويمكن إعادتها بأي نسبة دون رسوم إضافية.':
    'The car is handed over with at least 85% charge, and can be returned at any level with no extra fees.',
  التأخير: 'Late return',
  'في الفترة النهارية، كل ساعة بعد {time} تُحسب {fee}.':
    'For daytime rentals, each hour after {time} is charged {fee}.',
  الأضرار: 'Damage',
  'يُسجَّل وضع السيارة عند الاستلام والتسليم، وأي خدوش جديدة تُقيَّم حسب جدول الأضرار.':
    "The car's condition is recorded at pickup and return, and any new scratches are assessed using the damage schedule.",
  الإضافات: 'Extras',
  'تُعاد عدّة الشواء والطبخ نظيفة. فقدان أي قطعة يُحتسب بسعرها.':
    'The BBQ and cooking kits are returned clean. Any missing item is charged at its price.',
  الاستخدام: 'Usage',
  'يُمنع التدخين داخل السيارة والقيادة خارج الطرق المعبدة.':
    'No smoking inside the car and no off-road driving.',
  'قرأت شروط الإيجار وأوافق عليها': 'I have read and agree to the rental terms',
  'تغيّرت شروط الإيجار. اقرأها ووافق عليها مجدداً.':
    'The rental terms have changed. Read and accept them again.',
  'الكود غير صالح لهذا التاريخ': "This code isn't valid for this date",
  'انتهت استخدامات هذا الكود': 'This code has been used up',
  'استخدمت هذا الكود من قبل': "You've already used this code",
  'الكود غير صالح': 'This code is not valid',
  الدفع: 'Payment',
  'ادفع العربون الآن والباقي عند الاستلام، أو ادفع المبلغ كاملاً.':
    'Pay the deposit now and the rest at pickup, or pay in full.',
  'طريقة الدفع': 'Payment option',
  عربون: 'Deposit',
  'الباقي {amount} نقداً أو بالبطاقة عند الاستلام.':
    'The remaining {amount} is paid in cash or by card at pickup.',
  'الباقي عند الاستلام.': 'The rest is paid at pickup.',
  'المبلغ كاملاً': 'Full amount',
  'لا شيء عليك عند الاستلام، فقط المطابقة.': 'Nothing to pay at pickup, just verification.',
  'هذه السيارة تتطلب الدفع الكامل عند الحجز': 'This car requires full payment when booking',
  'لا يتوفر عربون لهذه السيارة. تدفع {amount} الآن، ولا شيء عليك عند الاستلام.':
    'No deposit option for this car. You pay {amount} now and nothing at pickup.',
  'كود الخصم': 'Discount code',
  'خصم {pct} مطبق': '{pct} discount applied',
  'لديك رصيد': 'You have credit of',
  'استخدمه في هذا الحجز': 'Use it on this booking',
  'يُخصم {amount}': '{amount} deducted',
  'لا يُجمع الرصيد مع كود الخصم. احذف الكود لاستخدام رصيدك.':
    "Credit can't be combined with a promo code. Remove the code to use your credit.",
  'تعذّر فتح صفحة الدفع': "We couldn't open the payment page",
  'حجزنا السيارة لك مؤقتاً. افتح صفحة الدفع مجدداً لإكمال الحجز.':
    'The car is held for you for now. Open the payment page again to complete the booking.',
  'افتح صفحة الدفع': 'Open the payment page',
  'رصيدك يغطي المبلغ المطلوب الآن': 'Your credit covers the amount due now',
  'لا حاجة لبطاقة. اضغط تأكيد الحجز.': 'No card needed. Tap Confirm booking.',
  'بطاقة بنكية': 'Bank card',
  'بوابة ثواني الآمنة': 'Secure Thawani gateway',
  'عند الضغط على «ادفع» تنتقل إلى صفحة ثواني لإدخال بيانات البطاقة، ثم تعود إلى هنا لتأكيد الحجز. نحجز السيارة لك {n} دقيقة حتى يكتمل الدفع.':
    "When you tap Pay, you go to Thawani's page to enter your card details, then come back here to confirm the booking. We hold the car for you for {n} minutes while you pay.",
  الموعد: 'When',
  السيارة: 'Car',
  الشروط: 'Terms',
  'مراحل الحجز': 'Booking stages',
  'إيجار نهاري': 'Daytime rental',
  'يوم كامل': 'Full day',
  'نهاية الأسبوع': 'Weekend',
  'تسعير موسم': 'season pricing',
  'تسليم بعد {time} ({n} س)': 'Return after {time} ({n} h)',
  'خصم الباقة': 'Package discount',
  خصم: 'Discount',
  'ضريبة القيمة المضافة {pct}': 'VAT {pct}',
  'ملخص الحجز': 'Booking summary',
  'لم تختر السيارة بعد': "You haven't chosen a car yet",
  الاستلام: 'Pickup',
  التسليم: 'Return',
  السعر: 'Price',
  'اختر سيارة': 'Choose a car',
  'نحسب السعر…': 'Calculating…',
  الإجمالي: 'Total',
  'شامل ضريبة القيمة المضافة {pct}:': 'Includes VAT {pct}:',
  'من رصيدك': 'From your credit',
  'الدفع كاملاً عند الحجز': 'Full payment at booking',
  'العربون الآن': 'Deposit now',
  'المبلغ كاملاً الآن': 'Full amount now',
  'الشحن مشمول، وأعد السيارة بأي نسبة بطارية.': 'Charging is included. Return the car at any battery level.',
  'تغيّر شيء في حجزك، راجع هذه الخطوة': 'Something changed in your booking. Please review this step',
  'اختر سيارة متاحة للمتابعة': 'Choose an available car to continue',
  'أكمل الحقول وارفع المستندين': 'Complete the fields and upload both documents',
  'وافق على الشروط للمتابعة': 'Accept the terms to continue',
  'ننتظر حساب المبلغ…': 'Waiting for the price…',
  الخطوة: 'Step',
  من: 'of',
  'المطلوب الآن': 'Due now',
  الرئيسية: 'Home',
  رجوع: 'Back',
  ادفع: 'Pay',
  'تأكيد الحجز': 'Confirm booking',
  التالي: 'Next',
  'ننقلك إلى بوابة الدفع الآمنة…': 'Taking you to the secure payment page…',
  'متى تريد الانطلاق؟': 'When do you want to set off?',
  'السعر يختلف بين الفترة النهارية واليوم الكامل.':
    'Price differs between the daytime period and a full day.',
  'نوع الإيجار': 'Rental type',
  نهاري: 'Daytime',
  'رحلة يوم للجبل والعودة مساءً. التسليم بعد {time} يضاف عليه {fee} لكل ساعة.':
    'A day trip up the mountain, back in the evening. Returns after {time} add {fee} per hour.',
  '24 ساعة': '24 hours',
  'للمبيت في الجبل. التسليم في نفس وقت الاستلام من اليوم التالي.':
    'For an overnight stay on the mountain. Return is at the same time as pickup the next day.',
  'تاريخ الاستلام': 'Pickup date',
  'وقت الاستلام': 'Pickup time',
  'من {time}': 'from {time}',
  'وقت التسليم': 'Return time',
  'عدد الأيام': 'Number of days',
  أقل: 'Less',
  أكثر: 'More',
  'الحجز مغلق في هذا اليوم، اختر يوماً آخر.': 'Bookings are closed on this day. Choose another day.',
  'انتهت مواعيد الاستلام لهذا اليوم، اختر يوماً آخر.':
    'Pickup times for this day have passed. Choose another day.',
  'كل السيارات محجوزة في هذا الموعد. جرّب وقتاً أو يوماً آخر.':
    'Every car is booked at this time. Try another time or day.',
  '{day} من أيام نهاية الأسبوع، وتنطبق عليه أسعارها.': '{day} is a weekend day, so weekend prices apply.',
  'أيام نهاية الأسبوع في رحلتك تُحسب بأسعارها.': 'Weekend days in your trip are charged at weekend prices.',
  'تسليم بعد {time} بـ {n} ساعة: يضاف {amount}': 'Returning {n} h after {time}: {amount} is added',
  'اختر السيارة': 'Choose a car',
  'المتاح في': 'Available on',
  '،': ',',
  السيارات: 'Cars',
  'دفع كامل عند الحجز': 'Full payment at booking',
  'محجوزة بالكامل': 'Fully booked',
  'آخر سيارة متاحة': 'Last car available',
  '{n} متاحة': '{n} available',
  'نتحقق من التوفر…': 'Checking availability…',
  'أضف ما تحتاجه للرحلة': 'Add what you need for the trip',
  'اختياري. تُجهّز في السيارة قبل الاستلام.': 'Optional. Prepared in the car before pickup.',
  'بدل ≈ {amount} لو اشتريتها': 'instead of ≈ {amount} to buy',
  'ضمن الباقة': 'In the package',
  'احجز رحلتك': 'Book your trip',
  'تعذّر تحميل الحجز الآن': "Booking can't be loaded right now",
  'حدّث الصفحة بعد لحظات، أو تواصل معنا على واتساب لنحجز لك.':
    "Refresh the page in a moment, or message us on WhatsApp and we'll book for you.",
  'حدّث الصفحة': 'Refresh the page',
  'لم يكتمل الدفع': 'Payment not completed',
  'لم نتمكن من العثور على الحجز. يمكنك الحجز من جديد.': "We couldn't find the booking. You can book again.",
  'احجز من جديد': 'Book again',
  'حاول مجدداً': 'Try again',
  'نتحقق من حالة الحجز…': 'Checking the booking…',
  'انتهت مهلة الدفع': 'The payment time ran out',
  'لم يكتمل الدفع خلال المهلة، فأُلغي حجز السيارة المؤقت. لم يُخصم منك شيء.':
    "The payment wasn't completed in time, so the temporary hold on the car ended. You haven't been charged.",
  'العودة للرئيسية': 'Back to home',
  'لم يُخصم منك شيء. أكمل الدفع لتأكيد الحجز، أو عدّل اختياراتك.':
    "You haven't been charged. Complete the payment to confirm the booking, or change your choices.",
  'السيارة محجوزة لك حتى {time}': 'The car is held for you until {time}',
  'بقي {n} دقيقة. بعدها تُتاح السيارة لغيرك.': '{n} min left. After that the car is released to others.',
  'رقم الحجز': 'Booking number',
  'أكمل الدفع': 'Complete payment',
  'عدّل الحجز': 'Change booking',
  'رابط الحجز غير مكتمل': 'This booking link is incomplete',
  'افتح الرابط كما وصلك، أو اعرض حجوزاتك برقم هاتفك.':
    'Open the link exactly as you received it, or see your bookings with your phone number.',
  حجوزاتي: 'My bookings',
  'لم نجد هذا الحجز': "We couldn't find this booking",
  'تعذّر التحقق من الحجز الآن': "We can't check the booking right now",
  'أُلغي هذا الحجز': 'This booking was cancelled',
  'هذا الحجز لم يعد قائماً. يمكنك الحجز من جديد في أي وقت.':
    'This booking no longer stands. You can book again any time.',
  'أُلغي الدفع قبل اكتماله.': 'The payment was cancelled before it finished.',
  'انتهت صلاحية صفحة الدفع قبل اكتماله.': 'The payment page expired before the payment finished.',
  'لم تستجب بوابة الدفع.': "The payment gateway didn't respond.",
  'السيارة محجوزة لك حتى {time}، ادفع الآن لتأكيد الحجز.':
    'The car is held for you until {time}; pay now to confirm the booking.',
  'ادفع مجدداً': 'Pay again',
  'لم يصلنا تأكيد الدفع بعد': "We haven't received the payment confirmation yet",
  'نؤكد دفعتك…': 'Confirming your payment…',
  'إذا أتممت الدفع فسيتأكد الحجز خلال دقائق ويصلك على واتساب. يمكنك التحقق مجدداً الآن.':
    'If you completed the payment, the booking will be confirmed within minutes and sent to you on WhatsApp. You can check again now.',
  'يستغرق ذلك عادةً بضع ثوانٍ. لا تغلق الصفحة.':
    'This usually takes a few seconds. Please keep this page open.',
  'تحقق مجدداً': 'Check again',
  'تم الحجز، رحلة موفقة': 'Booked. Enjoy the drive',
  'أرسلنا العقد إلى واتساب.': "We've sent the contract to WhatsApp.",
  المدفوع: 'Paid',
  'منها {amount} من رصيدك': 'including {amount} from your credit',
  'المتبقي عند الاستلام': 'Balance due at pickup',
  'أحضر البطاقة والرخصة الأصليتين. نطابقها ونسجّل العداد ونسبة البطارية ثم تنطلق.':
    "Bring your original ID card and licence. We verify them, log the odometer and battery level, and you're on your way.",
  'تغيّرت خططك؟': 'Plans changed?',
  'لا يُلغى الحجز، لكن يمكنك تحويله إلى رصيد من «حجوزاتي» حتى':
    "Bookings can't be cancelled, but you can convert yours to credit from My bookings until",
  'معاينة رسالة واتساب': 'WhatsApp message preview',
  'مسار EV لتأجير السيارات': 'Masar EV Car Rental',
  'حساب تجاري': 'Business account',
  مرحباً: 'Hello',
  'تم تأكيد حجزك': 'Your booking is confirmed',
  الآن: 'Now',
  'عقد-إيجار': 'rental-contract',
  'عقد الإيجار وشروطه. موقعنا: بركة الموز قبل نقطة التفتيش.':
    'The rental contract and its terms. Our location: Birkat Al Mouz, before the checkpoint.',
  'تم الحجز': 'Booked',
  'تم تحويل الحجز إلى رصيد': 'Booking converted to credit',
  'أضفنا {amount} إلى رصيدك.': 'We added {amount} to your credit.',
  'طلبك قيد المراجعة': 'Your request is under review',
  'أرسلت الطلب {when}. سيصلك إشعار على واتساب عند اعتماده.':
    "You sent the request on {when}. You'll be notified on WhatsApp once it's approved.",
  'رُفض طلب التحويل': 'Conversion request declined',
  'تواصل معنا على واتساب لمعرفة السبب.': 'Message us on WhatsApp to find out why.',
  'لا يمكن تحويل هذا الحجز إلى رصيد': "This booking can't be converted to credit",
  'الرحلة جارية الآن.': 'The trip is in progress.',
  'الحجز بانتظار الدفع.': 'The booking is waiting for payment.',
  'الحجز منتهٍ.': 'The booking has ended.',
  'يمكنك تحويل الحجز إلى رصيد': 'You can convert the booking to credit',
  'نحوّل {amount} (ما دفعته) إلى رصيد تستخدمه في أي حجز قادم. آخر موعد للطلب: {deadline}.':
    'We convert {amount} (what you paid) into credit for any future booking. Last time to ask: {deadline}.',
  'اطلب التحويل إلى رصيد': 'Request conversion to credit',
  'غير قابل للاسترداد': 'Non-refundable',
  'بقي أقل من {hours} ساعة على موعد الاستلام (آخر موعد كان {deadline}). حسب سياسة الإيجار لا يُلغى الحجز ولا يُحوّل إلى رصيد.':
    "Less than {hours} hours remain before pickup (the deadline was {deadline}). Under the rental policy the booking can't be cancelled or converted to credit.",
  'رصيدك الحالي': 'Your current credit',
  الفواتير: 'Invoices',
  'إشعار دائن': 'Credit note',
  إيصال: 'Receipt',
  فاتورة: 'Invoice',
  تنزيل: 'Download',
  'الفواتير والإيصالات': 'Invoices and receipts',
  'كل ما صدر لحجوزاتك: الإيصالات عند الدفع، والفاتورة بعد إرجاع السيارة، والإشعارات الدائنة.':
    'Everything issued for your bookings: receipts when you pay, the invoice once the car is back, and credit notes.',
  'لا توجد فواتير بعد.': 'No invoices yet.',
  'عرض الحجز #{ref}': 'Show booking #{ref}',
  'أرسلنا طلبك، سيصلك الرد على واتساب': "We've sent your request. You'll get a reply on WhatsApp",
  'تحويل الحجز #{ref} إلى رصيد؟': 'Convert booking #{ref} to credit?',
  إلغاء: 'Cancel',
  'أرسل الطلب': 'Send request',
  'نحوّل {amount} (ما دفعته) إلى رصيد تستخدمه في أي حجز قادم. بعد الموافقة لا يمكن استخدام هذا الحجز.':
    'We convert {amount} (what you paid) into credit for any future booking. Once approved, this booking can no longer be used.',
  'ملاحظة (اختياري)': 'Note (optional)',
  'انتهاء صلاحية الرصيد': 'Credit expired',
  'تحويل حجز إلى رصيد': 'Convert booking to credit',
  'استخدام في حجز': 'Used on a booking',
  'رصيد من مسار EV': 'Credit from Masar EV',
  'إلغاء قيد سابق': 'Earlier entry reversed',
  'تعديل على الرصيد': 'Credit adjustment',
  رصيدك: 'Your credit',
  'يُستخدم الرصيد تلقائياً عند الحجز من الموقع وأنت مسجّل الدخول، أو عند المكتب.':
    'Your credit is used when you book on the website while signed in, or at the desk.',
  'لا توجد حركات على رصيدك بعد.': 'No credit activity yet.',
  'عرض المزيد': 'Show more',
  'سجّل الدخول برقم هاتفك': 'Sign in with your phone number',
  'ستظهر هنا حجوزاتك وحالتها ورصيدك.': 'Your bookings, their status and your credit will appear here.',
  'سجّلت الخروج': "You've signed out",
  حسابي: 'My account',
  'مرحباً {name}': 'Hello {name}',
  خروج: 'Sign out',
  الحجوزات: 'Bookings',
  الرصيد: 'Credit',
  'لا توجد حجوزات بهذا الرقم بعد.': 'No bookings under this number yet.',
  'لا توجد حجوزات بعد': 'No bookings yet',
  'ستظهر هنا تفاصيل الحجز وحالته ورصيدك.': 'Your booking details, status and credit will appear here.',
  'لم نجد هذا الحجز في حسابك.': "We couldn't find this booking in your account.",
  'محاولات كثيرة. حاول بعد {n} ثانية.': 'Too many attempts. Try again in {n} seconds.',
  'ادخل برقم هاتفك': 'Sign in with your phone',
  'نرسل لك رمز تحقق على واتساب. استخدم الرقم الذي حجزت به.':
    "We'll send you a code on WhatsApp. Use the number you booked with.",
  'أرسل الرمز على واتساب': 'Send the code on WhatsApp',
  'أدخل الرمز': 'Enter the code',
  'إذا كان لهذا الرقم حجوزات لدينا، أرسلنا رمزاً من 6 أرقام إلى واتساب':
    "If this number has bookings with us, we've sent a 6-digit code on WhatsApp to",
  'رمز التحقق': 'Verification code',
  تحقق: 'Verify',
  'غيّر الرقم': 'Change number',
  'أعد الإرسال بعد {n} ث': 'Resend in {n} s',
  'أعد إرسال الرمز': 'Resend the code',
  'تابع حجزك وحوّله إلى رصيد': 'Track your booking and convert it to credit',
  'لا يمكن إلغاء الحجز، لكن يمكنك تحويله إلى رصيد إذا طلبت ذلك قبل {period} على الأقل من موعد الاستلام.':
    "Bookings can't be cancelled, but you can convert yours to credit if you ask at least {period} before pickup.",
  'بانتظار الدفع': 'Awaiting payment',
  مؤكد: 'Confirmed',
  'جارٍ الآن': 'In progress',
  مكتمل: 'Completed',
  'محوّل إلى رصيد': 'Converted to credit',
  ملغي: 'Cancelled',
  'انتهت المهلة': 'Expired',
  'رمز الدولة': 'Country code',
  إغلاق: 'Close',
  'جارٍ التحميل…': 'Loading…',
  عُمان: 'Oman',
  الإمارات: 'UAE',
  السعودية: 'Saudi Arabia',
  قطر: 'Qatar',
  البحرين: 'Bahrain',
  الكويت: 'Kuwait',
  الأردن: 'Jordan',
  مصر: 'Egypt',
  لبنان: 'Lebanon',
  العراق: 'Iraq',
  اليمن: 'Yemen',
  المغرب: 'Morocco',
  تونس: 'Tunisia',
  الجزائر: 'Algeria',
  السودان: 'Sudan',
  الهند: 'India',
  باكستان: 'Pakistan',
  بنغلاديش: 'Bangladesh',
  الفلبين: 'Philippines',
  'المملكة المتحدة': 'United Kingdom',
  ألمانيا: 'Germany',
  فرنسا: 'France',
  إيطاليا: 'Italy',
  روسيا: 'Russia',
  الصين: 'China',
  'الولايات المتحدة / كندا': 'United States / Canada',
};
